import { connect } from 'react-redux';
import { getData, getAndStore } from '../../../actions/utils';
import { submitAlarmConfig, deleteMachineConfig } from '../../../actions/alarmsConfig';
import SettingsAlarms from './SettingsAlarms';
import commonActions from '../../../actions/common';
import alarmsConfigSchema from '../../../normalizr-schemas/alarmsConfigSchema';

const alarmsConfigActions = commonActions('alarmsConfig');

const mapStateToProps = ({ alarmsConfig, alarmsConfigOpen, editAlarmsConfigModalOpen }) => ({
  alarmsConfig,
  alarmsConfigOpen,
  editAlarmsConfigModalOpen,
});

const mapDispatchToProps = dispatch => ({
  getAlarmsConfig: () => dispatch(getData('alarmsConfig', 'alarms-config', alarmsConfigSchema, true, { limit: 10 })),
  loadMore: () => dispatch(getAndStore('alarmsConfig', 'alarms-config', alarmsConfigSchema, true, { limit: 10 })),
  openNewAlarmConfigModal: () => dispatch(alarmsConfigActions.openAddModal()),
  closeDeleteMachineConfigModal: id => dispatch(alarmsConfigActions.closeDeleteModal(id)),
  openDeleteMachineConfigModal: id => dispatch(alarmsConfigActions.openDeleteModal(id)),
  deleteMachineConfig: id => dispatch(deleteMachineConfig(id)),
  openEditAlarmsConfigModal: id => dispatch(alarmsConfigActions.openEditModal(id)),
  closeEditAlarmsConfigModal: id => dispatch(alarmsConfigActions.closeEditModal(id)),
  submitAlarmConfig: newConfig => dispatch(submitAlarmConfig(newConfig)),
});

const SettingsAlarmsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsAlarms);

export default SettingsAlarmsContainer;



// WEBPACK FOOTER //
// ./src/components/Settings/alarms/SettingsAlarmsContainer.js